import type { ApiTmpStorageId } from '#/api/types/ApiTypedId';
import { postJson } from '#/utils/http/postJson';

export async function apiCreateTmpStorage(
  state: unknown,
): Promise<ApiTmpStorageId> {
  const { data } = await postJson<{ data: { id: string } }>(
    '/data/tmp-storage',
    { data: JSON.stringify(state) },
  );

  return data.id;
}
